import React, { Component } from 'react';
import _, { flowRight as compose } from 'lodash';
import moment from 'moment';
import { inject, observer } from 'mobx-react';
import { Grid, Box, Accordion, AccordionSummary, AccordionDetails, Button } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

import styles, { Status } from './styles';
import acl from 'constants/acl';
import { getDropoffAddress } from '../MiniStopBox/shipment';
import CorrectedAddress from '../CorrectedAddress';
import TimeWithTimezone from 'components/TimeWithTimezone';

class ShipmentDropoffInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleOpenDropOffDialog = () => {
    const { store } = this.props;
    const { permissionStore } = store;
    const isDenied = permissionStore.isDenied(acl.ASSIGNMENTS.UPDATE_DROP_OFF);

    if (isDenied) return;

    this.props.openForm('AccessCode')();
  };

  render() {
    const { dropoff, shipment, pickup, store } = this.props;
    const { permissionStore } = store;
    const dropoffStatus = dropoff?.status ? dropoff.status : '';
    const statusColor = !!dropoffStatus ? Status[dropoffStatus] : Status['DEFAULT'];
    const dtFormat = moment(shipment.dropoff_latest_ts).isBefore(moment()) ? 'MM/DD hh:mm A' : 'hh:mm A';
    const isHideEdit = shipment.dropoff_access_code || shipment.dropoff_additional_instruction;
    const isDisableAddNote = pickup && dropoff && !(['SUCCEEDED'].includes(dropoff.status) && ['SUCCEEDED'].includes(pickup.status));
    const isShowAccessCode = isHideEdit || isDisableAddNote;
    const isDeniedEdit = permissionStore.isDenied(acl.ASSIGNMENTS.UPDATE_DROP_OFF);

    const street = shipment?.dropoff_address?.street;
    const street2 = shipment?.dropoff_address?.street2;
    const address = `${shipment?.dropoff_address?.city || ''} ${shipment?.dropoff_address?.state || ''} ${shipment?.dropoff_address?.zipcode || ''}`;

    const { shipmentStore } = store;
    const { assignmentStore } = store;
    const { shipmentInfo } = shipmentStore;
    const { selectedAssignment } = assignmentStore;
    const correctedInfo = getDropoffAddress(
      shipment,
      shipment?.assignment_id ? selectedAssignment : { customer_profiles: [shipmentInfo.customer_profile || {}] },
    );
    const streetCorrected = correctedInfo?.dropoff_address?.street;
    const street2Corrected = correctedInfo?.dropoff_address?.street2;
    const addressCorrected = `${correctedInfo?.dropoff_address?.city} ${correctedInfo?.dropoff_address?.state} ${correctedInfo?.dropoff_address?.zipcode}`;
    const driverOTD = shipment?.delivery_by_date_time;

    return (
      <Box>
        <Accordion sx={styles.panelContainer} defaultExpanded={true}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={styles.panelHeader}
            slotProps={{ expandIconWrapper: { sx: styles.panelToggleIcon } }}
          >
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid>
                <Box sx={styles.panelHeaderTitle}>Dropoff Info:</Box>
              </Grid>
              <Grid>
                <Box style={{ color: statusColor }} sx={styles.panelHeaderStatus}>
                  <span>{dropoffStatus}</span>
                  {dropoff?.actual_departure_ts && <span> @ {moment(dropoff.actual_departure_ts).format(dtFormat)}</span>}
                </Box>
              </Grid>
            </Grid>
          </AccordionSummary>
          <AccordionDetails sx={styles.panelBody}>
            <Grid container direction="column" spacing={1}>
              <Grid>
                <Grid container justifyContent="space-between">
                  <Grid>
                    <CorrectedAddress originValue={street} correctedValue={streetCorrected} originStyle={styles.paragraph} />
                    <CorrectedAddress originValue={street2} correctedValue={street2Corrected} originStyle={styles.paragraph} />
                    <CorrectedAddress originValue={address} correctedValue={addressCorrected} originStyle={styles.paragraph} />
                  </Grid>
                  {shipment.dropoff_note && (
                    <Grid>
                      <Box sx={styles.noteLabel}>NOTES</Box>
                      <Box sx={styles.noteContent}>{shipment.dropoff_note}</Box>
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid>
                <Grid container wrap="wrap" justifyContent="space-between" gap={0.5} sx={styles.timeWindow}>
                  <Grid>
                    <Box sx={styles.timeLabel}>Driver OTD:</Box>
                    <TimeWithTimezone
                      variant="tooltip"
                      timeTs={driverOTD}
                      timezone={shipment.timezone}
                      valueSx={styles.timeValue}
                    />
                  </Grid>
                  
                  <Grid>
                    <Box sx={styles.timeLabel}>ETA:</Box>
                    <TimeWithTimezone
                      variant="tooltip"
                      timeTs={dropoff?.estimated_arrival_ts}
                      timezone={shipment.timezone}
                      valueSx={styles.timeValue}
                    />
                  </Grid>
                  
                  {dropoff?.actual_departure_ts && (
                    <Grid>
                      <Box sx={styles.timeLabel}>Actual Dropoff:</Box>
                      <TimeWithTimezone
                        variant="tooltip"
                        timeTs={dropoff.actual_departure_ts}
                        timezone={shipment.timezone}
                        valueSx={styles.timeValue}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid>
                <Grid container justifyContent="space-between" alignItems="center" style={{ color: statusColor }} sx={styles.remarkHeader}>
                  <Grid>
                    <Box sx={styles.remarkHeaderStatus}>DROPOFF REMARK</Box>
                  </Grid>
                  {dropoffStatus && (
                    <Grid>
                      <Box sx={styles.remarkHeaderTime}>
                        {_.capitalize(dropoffStatus)}
                        {dropoff?.actual_departure_ts && <span> @ {moment(dropoff.actual_departure_ts).format(dtFormat)}</span>}
                      </Box>
                    </Grid>
                  )}
                </Grid>
                <Box sx={{ ...styles.remarkContent, borderColor: statusColor }}>
                  {dropoff?.remark ? dropoff.remark : '-'}
                </Box>
              </Grid>
              {isShowAccessCode && (
                <Grid>
                  <Grid container>
                    <Box sx={styles.accessCodeContainer}>
                      <Box sx={styles.codeBlock}>
                        <div style={{ cursor: isHideEdit ? 'default' : 'pointer', flex: 1 }}>
                          <Box sx={styles.dropoffAccessContentLabel}>
                            {shipment.dropoff_access_code ? (
                              <Box component="span" sx={styles.accessLabel}>
                                {`Access code:`} <span style={{ color: '#000' }}>{shipment.dropoff_access_code}</span>
                              </Box>
                            ) : shipment.dropoff_additional_instruction ? (
                              ''
                            ) : (
                              isDisableAddNote && (
                                <Box sx={styles.accessLabel} onClick={this.handleOpenDropOffDialog}>
                                  {'+ Access Code / Additional Instruction'}
                                </Box>
                              )
                            )}
                          </Box>
                        </div>
                        {isHideEdit && dropoff && !dropoff._deleted && !isDeniedEdit && (
                          <Button size="small" sx={styles.grayBtn} onClick={this.handleOpenDropOffDialog}>{`Edit`}</Button>
                        )}
                      </Box>
                      <div>
                        {shipment.dropoff_additional_instruction && (
                          <div>
                            <Box component="span" sx={styles.accessLabel}>{`Additional Instruction:`}</Box>
                            <span>{shipment.dropoff_additional_instruction}</span>
                          </div>
                        )}
                      </div>
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Box>
    );
  }
}

export default compose(inject('store'), observer)(ShipmentDropoffInfo);
